<template>
    <div class="search-result">
        <div class="left-wrap">
            <div v-if="value.result && value.result !== value.keyWord">
                <span>Search results for "</span>
                <span class="result-text">{{value.result}}</span>
                <span>" are displayed。</span>
                <span>Search still：</span>
                <span class="search-key" @click="search">{{value.keyWord}}</span>
            </div>
            <div v-else>
                <span>The number of results you are searching is about </span>
                <span>{{value.rsCount}}</span>
                <!--        <span>个</span>-->
            </div>
        </div>
        <div class="right-wrap">
            <div :class="{'active-item': selectType === '混合排序'}" @click="sortList('混合排序')">
                Mixed
                <i class="el-icon-bottom"></i>
            </div>
            <div :class="{'active-item': selectType === '相关度'}" @click="sortList('相关度')">
                Relevancy
                <i class="el-icon-bottom"></i>
            </div>
            <div @click="sortList('published')" :class="{'active-item': selectType === 'published'}">Time
                <i class="el-icon-bottom"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'searchResult',
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      selectType: '混合排序',
      sortTime: false, // false 为倒 2
      sortRalation: false // false 为倒2
    }
  },
  methods: {
    search () {
      this.$emit('search', this.value.keyWord)
    },
    sortList (val) { // 切换排序方式
      this.selectType = val
      this.$emit('sortList', val)
    }
  }
}
</script>

<style scoped lang="scss">
    @media screen and (max-width: 555px) {
        .p-ss-none {
            display: none !important;
        }

        .search-result {
            align-items: flex-start !important;
            flex-direction: column;
            padding-bottom: 8px !important;
            box-sizing: content-box;
        }
    }

    .search-result {
        width: 100%;
        /*height: 100%;*/
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left-wrap {
            display: flex;
            height: 100%;
            align-items: center;
            color: #6C757D;

            .result-text {
                color: #333333;
            }

            .search-key {
                cursor: pointer;
                border-bottom: 1px solid #208EFF;
                color: #208EFF;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
            }
        }

        .right-wrap {
            height: 32px;
            display: flex;
            align-items: center;

            div {
                width: 90px;
                height: 32px;
                cursor: pointer;
                line-height: 32px;
                text-align: center;
                border: 1px solid #C0C4CC;

                &:hover {
                    color: #208EFF;
                }
            }

            .active-item {
                border: 1px solid #208EFF;
                background: rgba(90, 171, 255, 0.1);
                color: #208EFF;
            }

            div:last-child {
                border-left: none;

                &.active-item {
                    border-left: 1px solid #208EFF;
                }
            }

            div:first-child {
                border-right: none;

                &.active-item {
                    border-right: 1px solid #208EFF;
                }
            }
        }
    }
</style>
